import './ApplyFormNew.scss'

import * as React from 'react'
import { Formik } from 'formik'

import { CustomSelect as Select } from '../Select/Select'
import TextInput from '../TextInput/TextInput'
import { applyFormValidator, applyFormInitialValues } from './ApplyFormValidations'


const options = [
  {
    label: 'Up to 1000',
    value: 'Up to 1000'
  },
  {
    label: '1000-5000',
    value: '1000-5000'
  },
  {
    label: '5000-25000',
    value: '5000-25000'
  },
  {
    label: '25000-100000',
    value: '25000-100000'
  },
  {
    label: 'More than 100000',
    value: 'More than 100000'
  }
]

interface IProps {
  onSubmit: (values, methods) => void;
  onNextClick?: (values, methods) => void;
}

export default class ContactForm extends React.PureComponent<IProps> {
  state = {
    currentStep: 1,
    // TODO: set steps components into separate component and count children instead of stepsCount
    stepsCount: 2,
    isLastStep: false
  }

  handleSubmit = (values: any, methods: any) => {
    if (this.state.isLastStep) {
      this.props.onSubmit(values, methods)
    } else {
      if (this.props.onNextClick) this.props.onNextClick(values, methods)

      this.setState((prevState) => {
        const stepNumber = prevState.currentStep + 1

        return {
          currentStep: stepNumber,
          isLastStep: stepNumber === prevState.stepsCount
        }
      })
    }

    methods.setSubmitting(false)
  }

  renderFirstStep(props) {
    const { handleChange, handleBlur, values, errors, touched } = props

    return (
      <React.Fragment>
        <TextInput
          label='What’s your name?'
          placeholder='Name'
          type='text'
          name='name'
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.name}
          error={errors.name}
          touched={touched.name}
        />
        <TextInput
          label='Email'
          placeholder='Type your email'
          type='email'
          name='email'
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.email}
          error={errors.email}
          touched={touched.email}
        />
        <TextInput
          label='What’s the name of your company?'
          placeholder='Name of company'
          type='text'
          name='company'
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.company}
          error={errors.company}
          touched={touched.company}
        />
      </React.Fragment>
    )
  }

  renderSecondStep(props) {
    const { handleChange, handleBlur, values, setFieldValue, setFieldTouched, errors, touched } = props

    return (
      <React.Fragment>
        {this.renderFirstStep(props)}
        <TextInput
          label='What’s your position?'
          placeholder='Brand manager'
          type='text'
          name='position'
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.position}
        />
        <TextInput
          label='Phone'
          placeholder='Type your phone number'
          type='tel'
          name='phone'
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.phone}
          error={errors.phone}
          touched={touched.phone}
        />
        <Select
          label='How many images do you need per month'
          placeholder='Images amount'
          options={options}
          name='imagesAmount'
          value={values.imagesAmount}
          onChange={setFieldValue}
          onBlur={setFieldTouched}
        />
        <TextInput
          label='Your comment'
          placeholder='Type your comment'
          type='text'
          name='comment'
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.comment}
        />
      </React.Fragment>
    )
  }

  render() {
    return (
      <Formik
        initialValues={applyFormInitialValues}
        validate={applyFormValidator}
        onSubmit={this.handleSubmit}
      >
        {({ handleSubmit, isSubmitting, ...props }) => {
          return (
            <form onSubmit={handleSubmit}>
              {this.state.currentStep === 1 && this.renderFirstStep(props)}

              {this.state.currentStep === 2 && this.renderSecondStep(props)}

              <div className='form-controls'>
                {this.state.isLastStep
                ?
                  <button
                    id='apply-form-submit'
                    type='submit'
                    className='btn-submit'
                    disabled={isSubmitting}
                  >
                    Submit
                  </button>
                  :
                  <button
                    id='apply-form-step-2'
                    type='submit'
                    className='btn-submit'
                    disabled={isSubmitting}
                  >
                    Next
                  </button>
                }
              </div>
            </form>
          )}
          }
      </Formik>
    )
  }
}
